import { getCurrentMonth } from '#/lib/utils';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface SPELLERCOUNT {
  count: number;
  lastUpdated: string; // 마지막 업데이트 날짜 저장
  setCount: (count: number) => void;
}

export const useSpellerCountLocal = create<SPELLERCOUNT>()(
  persist(
    (set) => ({
      // 2. 초기 상태에 count와 lastUpdated 설정
      count: 0,
      lastUpdated: getCurrentMonth(),
      // setCount가 호출될 때마다 날짜도 함께 업데이트
      setCount: (count) => set({ count, lastUpdated: getCurrentMonth() })
    }),
    {
      name: 'speller-count-storage', // localStorage 키
      storage: createJSONStorage(() => localStorage),

      // 3. merge 함수를 사용하여 상태 병합 로직 커스터마이징
      merge: (persistedState, currentState) => {
        // localStorage의 날짜가 오늘과 다르면, 초기 상태를 반환 (카운트 리셋)
        if (
          (persistedState as SPELLERCOUNT).lastUpdated !== getCurrentMonth()
        ) {
          return currentState;
        }

        // 날짜가 같다면, localStorage 데이터와 현재 상태의 함수들을 합쳐서 반환
        // 여기가 수정된 부분입니다!
        return { ...currentState, ...(persistedState as SPELLERCOUNT) };
      }
    }
  )
);
